export enum AuthErrorCode {
  refreshTokenExpired = 'refreshTokenExpired',
  refreshTokenNotFound = 'refreshTokenNotFound',
  refreshTokenInvalid = 'refreshTokenInvalid',
  refreshFailed = 'refreshFailed',
  notAuthorized = 'notAuthorized',
  switchRejected = 'switchRejected'
}

export class AuthError extends Error {
  code?: AuthErrorCode
  /** Server's machine-readable reason (`extensions.reason`), when it sends one. */
  reason?: string

  static create({ code, message, reason, options }: { code: AuthErrorCode, message: string, reason?: string, options?: ErrorOptions }) {
    const error = new AuthError(message, options)
    error.code = code
    error.reason = reason
    return error
  }
}
